import React from "react";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";

import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

import TitleActions from "../actions/TitleActions";
import TitleStore from "../stores/TitleStore";

import LinkLike from "./partials/link-like.jsx";

class AcceptCreatorInvite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      name: "",
      organization: "",
      password: "",
      confirmPassword: "",
      hasStartedConfirming: false,
      activating: false
    };

    this._signup = this._signup.bind(this);
    this._accept = this._accept.bind(this);
  }

  static getStores() {
    return [UserStore, TitleStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  _signup() {
    this.setState({ activating: true });
    UserActions.userSignup({
      type: "content_creator",
      email: this.state.username,
      password: this.state.password,
      name: this.state.name,
      organization: this.state.organization
    });
  }

  _accept(title) {
    UserActions.acceptContentCreatorInvite({
      token: this.props.location.query.token,
      title
    });
  }

  componentWillMount() {
    if (this.props.isLoggedIn) {
      TitleActions.fetchAll();
    }
    UserActions.lookupContentCreatorInvite(this.props.location.query.token);
  }

  componentWillReceiveProps(newProps) {
    const invite =
      newProps.contentCreatorInvites[this.props.location.query.token];

    if (invite && invite.email && !this.state.username) {
      this.setState({ username: invite.email });
    }

    // Fetch titles for title_requested_media mode
    if (newProps.isLoggedIn && !this.props.isLoggedIn) {
      TitleActions.fetchAll.defer();
    }
  }

  getStyles() {
    return {
      container: {
        margin: "10% auto 5%",
        width: 375,
        fontSize: "11pt",
        textAlign: "center"
      },
      bodyText: {
        textAlign: "left",
        marginBottom: "0.5em"
      },
      actions: {
        marginTop: "1em",
        textAlign: "center"
      },
      terms: {
        textAlign: "center",
        fontSize: "10pt",
        lineHeight: 1.5,
        color: "#a7a7a7",
        maxWidth: 270,
        margin: "1em auto 0"
      },
      termsLink: {
        color: "#8a8a8a"
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    let styles = this.getStyles();
    const error = this.props.loginErrorMessage;

    const invite =
      this.props.contentCreatorInvites[this.props.location.query.token];

    const userTitles = TitleStore.getTitles();

    if (!invite && this.props.contentCreatorInviteLookupErrorMessage) {
      return (
        <div style={styles.container}>
          <div style={styles.error}>
            <p>
              Failed to accept invite: This invite may have been revoked, or
              perhaps has already been accepted.
            </p>{" "}
            <p>
              Please try{" "}
              <Link
                to={{
                  pathname: "/login"
                }}
                style={styles.alreadyHaveAccount}
              >
                logging in
              </Link>{" "}
              instead, or{" "}
              <LinkLike
                onTouchTap={() =>
                  Intercom(
                    "showNewMessage",
                    `I am having trouble accepting a Content Creator invitation. My name, organization, and film are: `
                  )
                }
              >
                send us a message
              </LinkLike>
              .
            </p>
          </div>
        </div>
      );
    }

    if (!invite) {
      return (
        <WorkingIndicator fullPage={true} style={{ margin: "10% auto" }} />
      );
    }

    if (this.props.isLoggedIn) {
      return (
        <div style={{ ...styles.container, textAlign: "center" }}>
          <div style={{ marginBottom: "1em" }}>
            <strong>{invite.user_name}</strong> has invited you to{" "}
            {invite.title_requested_media ? `deliver assets` : `upload content`}{" "}
            for <strong>{invite.film_name}</strong>, screening within{" "}
            <strong>{invite.event_bucket_name}</strong>.
          </div>
          {invite.title_requested_media ? (
            <div>
              <div style={{ marginBottom: "1em" }}>
                You can fulfill this asset request using a title from your
                Eventive account. Please select an existing title, or create a
                new one.
              </div>
              <div style={{ marginBottom: "2em" }}>
                {TitleStore.getState().isFetching ? (
                  <div style={{ fontStyle: "italic", marginBottom: 10 }}>
                    Loading your titles...
                  </div>
                ) : (
                  <div>
                    {userTitles.length === 0 ? (
                      <div style={{ fontStyle: "italic", marginBottom: 10 }}>
                        No existing titles found.
                      </div>
                    ) : null}
                    {userTitles
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .concat([{ id: "new", new: true }])
                      .map(title => (
                        <div key={title.id} style={{ marginBottom: "1em" }}>
                          <RaisedButton
                            primary={title.new}
                            disabled={this.props.acceptInProgress}
                            label={title.new ? "Create new title" : title.name}
                            onTouchTap={() =>
                              this._accept(title.new ? true : title.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ marginBottom: "1em" }}>
              <RaisedButton
                label={
                  this.props.acceptInProgress ? "Accepting..." : "Accept invite"
                }
                disabled={this.props.acceptInProgress}
                primary={true}
                onTouchTap={() => this._accept()}
              />
            </div>
          )}
          <LinkLike
            onTouchTap={() => UserActions.logout(true)}
            style={{ fontSize: "0.9em" }}
          >
            Log out and accept as a different user
          </LinkLike>
        </div>
      );
    }

    const notReady =
      this.props.loginInProgress ||
      !this.state.username ||
      !this.state.password ||
      !this.state.name ||
      !this.state.organization ||
      !this.state.organization.trim() ||
      this.state.password !== this.state.confirmPassword;

    return (
      <div style={styles.container}>
        {error ? (
          <div style={styles.error}>Failed to activate account: {error}</div>
        ) : (
          <div style={styles.bodyText}>
            <div>
              Welcome to Eventive for Content Creators. To begin{" "}
              {invite.title_requested_media
                ? `delivering assets`
                : `uploading content`}{" "}
              for "{invite.film_name}", please create an account below, or{" "}
              <Link
                to={{
                  pathname: "/login",
                  query: {
                    next: encodeURIComponent(
                      this.props.location.pathname + this.props.location.search
                    )
                  },
                  state: { username: this.state.username }
                }}
                style={styles.alreadyHaveAccount}
              >
                login to an existing account
              </Link>
              .
            </div>
            <div style={{ marginTop: "1em" }}>
              Please ensure the information you provide is accurate, as it will
              be used to verify and protect your rights to the content.
            </div>
          </div>
        )}
        <form>
          <div>
            <TextField
              floatingLabelText="Email address"
              floatingLabelFixed={true}
              value={this.state.username}
              onChange={e => this.setState({ username: e.target.value })}
              disabled={this.props.loginInProgress}
            />
          </div>
          <div>
            <TextField
              floatingLabelText="Full name"
              floatingLabelFixed={true}
              value={this.state.name}
              onChange={e => this.setState({ name: e.target.value })}
              disabled={this.props.loginInProgress}
              autoFocus
            />
          </div>
          <div>
            <TextField
              floatingLabelText="Company / legal name"
              floatingLabelFixed={true}
              value={this.state.organization}
              onChange={e => this.setState({ organization: e.target.value })}
              disabled={this.props.loginInProgress}
            />
          </div>
          <div>
            <TextField
              floatingLabelText="New password"
              floatingLabelFixed={true}
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              type="password"
              autoComplete="new-password"
              disabled={this.props.loginInProgress}
            />
          </div>
          <div>
            <TextField
              floatingLabelText="Confirm new password"
              floatingLabelFixed={true}
              value={this.state.confirmPassword}
              onChange={e =>
                this.setState({
                  hasStartedConfirming: true,
                  confirmPassword: e.target.value
                })
              }
              onKeyDown={e => {
                if (e.keyCode === 13 && !notReady) this._signup();
              }}
              errorText={
                this.state.hasStartedConfirming &&
                this.state.password !== this.state.confirmPassword
                  ? "The passwords do not match."
                  : null
              }
              type="password"
              autoComplete="new-password"
              disabled={this.props.loginInProgress}
            />
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label={
                this.props.loginInProgress
                  ? "Activating..."
                  : "Activate account"
              }
              disabled={notReady}
              primary={true}
              onTouchTap={this._signup}
            />
          </div>
          <div style={styles.terms}>
            By activating your account, you agree to the Eventive{" "}
            <a
              href="https://eventive.org/terms"
              target="_blank"
              style={styles.termsLink}
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://eventive.org/privacy"
              target="_blank"
              style={styles.termsLink}
            >
              Privacy&nbsp;Policy
            </a>
            .
          </div>
        </form>
      </div>
    );
  }
}

export default connectToStores(AcceptCreatorInvite);



// WEBPACK FOOTER //
// ./src/app/components/accept-creator-invite.jsx